module.exports = __webpack_public_path__ + "shallow_l.270368a3.png";